import { defineComponent as _defineComponent } from 'vue'
import QRCode from "qrcode"

import { onMounted, ref } from 'vue'
import type { Ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Qr-code',
  props: ['qr-code', 'scale'],
  setup(__props, { expose }) {
  expose();

const code = __props

const canvas: Ref = ref(null)

const options = {
  version: 0,
  mode: 'numeric',
  scale: code.scale? code.scale : 11,
  maskPattern: 0,
  margin: 0,
  color: {
    dark: '#000000',
    light: '#ffffff',
  }
}

onMounted(() => {
  try {
    QRCode.toCanvas(canvas.value, code.qrCode || "test", options, function (error) {
      if (error) console.error(error)
    })
  } catch (e) {
    return Promise.reject(e)
  }
})

const __returned__ = { canvas, code, options, QRCode, onMounted, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})